import { BUYER, SELLER, SUPPLIER } from "codes";
import { GTC_TYPE_BUYER, GTC_TYPE_SUPPLIER, type GtcType } from "constants/gtc";

export const resolveGtcType = (
  profile: string | undefined | null,
): GtcType | null => {
  const normalized = (profile ?? "").trim().toLowerCase();
  if (!normalized) {
    return null;
  }
  if (normalized === BUYER.toLowerCase()) {
    return GTC_TYPE_BUYER;
  }
  if (
    normalized === SELLER.toLowerCase() ||
    normalized === SUPPLIER.toLowerCase()
  ) {
    return GTC_TYPE_SUPPLIER;
  }
  return null;
};
